module.exports = __webpack_public_path__ + "static/media/DSC04888.6d19206a.png";